// NoPermissionScreen.jsx
import React from 'react';
import { ExclamationCircle } from 'react-bootstrap-icons';

const NoPermission = () => {
  const handleLogout = () => {
    window.location.href = '/Logout';
  };

  return (
    <div className="position-fixed d-flex align-items-center justify-content-center bg-dark w-100 h-100">
      <div className="bg-primary-container p-3 rounded">
        <div className="d-flex flex-column align-items-center">
          <ExclamationCircle size={50} />
          <h2>Restricted Area</h2>
          <p>You do not have permission to access this function.</p>
          <p>Please contact your administrator if you believe you should have access</p>
          <div className="text-center mt-3">
            <button onClick={handleLogout} className="btn">
              Ok
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NoPermission;
